import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '@env/environment';
import { AuthenticationService } from '@services/authentication.service';
import { StorageService } from '@services/storage.service';
import { catchError, Observable, switchMap, throwError } from 'rxjs';

@Injectable()
export class HeaderInterceptor implements HttpInterceptor {
  private router = inject(Router);
  private authenticationService = inject(AuthenticationService);
  private storageService = inject(StorageService);

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const isStorageRequest = request.url.startsWith(environment.storageUri);

    if (isStorageRequest) {
      const cleanRequest = request.clone({
        headers: request.headers
          .delete('Authorization')
          .delete('x-functions-key')
          .delete('x-client-id')
          .delete('Accept-Language')
          .delete('route'),
        withCredentials: false
      });

      return next.handle(cleanRequest);
    }

    const authenticatedRequest = request.clone({
      setHeaders: {
        'Accept-Language': this.storageService.getLocalItem('selectedLanguage') || environment.defaultLanguage,
        'x-functions-key': environment.functionKey,
        'x-client-id': environment.clientId,
        'route': this.router.routerState.snapshot.url
      },
      withCredentials: true
    });

    return next.handle(authenticatedRequest).pipe(
      catchError((error) => {
        if (error.status !== 401 ||
          this.authenticationService.isAuthenticationRequest(request.url) ||
          !this.authenticationService.isAuthorizedSnapshot()) {
          return throwError(() => error);
        }

        return this.authenticationService.refreshToken().pipe(
          switchMap(() => next.handle(authenticatedRequest)),
          catchError((refreshError) => {
            this.authenticationService.handleUnauthorized();
            return throwError(() => refreshError);
          })
        );
      })
    );
  }
}
